import type {
  InputProps
} from '@chakra-ui/react'
import {
  InputGroup as ChakraInputGroup,
  FormErrorMessage,
  FormHelperText,
  Input,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react'
import type { FieldError } from 'BrokerTsLib/src/rhf'
import React, { forwardRef } from 'react'

export interface InputGroupProps extends InputProps {
  errors?: FieldError | undefined
  selectAllonFocus?: boolean | undefined
  leftElement?: string | React.ReactNode
  rightElement?: string | React.ReactNode
  formHelperText?: string | React.ReactNode
}

export const InputGroup
  = forwardRef(
    (
      {
        errors,
        selectAllonFocus = false,
        leftElement,
        rightElement,
        formHelperText,
        htmlSize,
        sx,
        children,
        ...rest
      }: InputGroupProps,
      ref: any,
    ) => {

      const handleFocus = (event: any) => {
        if (selectAllonFocus) event.target.select()
      }

      const errorMessage = errors && errors?.message

      return (
        <ChakraInputGroup sx={{ w: '100%', display: 'grid', gap: 2, ...sx }}>
          {leftElement && <InputLeftElement children={leftElement} />}

          <Input onFocus={handleFocus} htmlSize={htmlSize} {...rest} ref={ref} />

          {rightElement && <InputRightElement sx={{ w: 'auto', px: 4 }} children={rightElement} />}

          {formHelperText &&
            <FormHelperText>
              {formHelperText}
            </FormHelperText>
          }

          {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}

          {children}
        </ChakraInputGroup>
      )
    },
  )
